import axios from 'axios';

export type LanguageJson = Record<string, Record<string, string>>;

export default class I18nService {
  static async loadLanguageJson(): Promise<LanguageJson> {
    let res = await axios.get('/api/i18n/language-file?mode=frontend&nested=false');
    if (res.status !== 200) {
      res = await axios.get('/language.json');
    }
    return res.data as LanguageJson;
  }
}
